var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable react/jsx-no-bind */
import React, { useLayoutEffect, useState } from 'react';
import { Paper, Popper, useTheme } from '@mui/material';
import { Container, Stack } from '@mui/system';
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import Typography from '../Typography';
var black = designTokens.color.shade.black.value;
var TutorialBase = function (_a) {
    var open = _a.open, anchorElement = _a.anchorElement, _b = _a.placement, placement = _b === void 0 ? 'auto' : _b, _c = _a.showBackDrop, showBackDrop = _c === void 0 ? true : _c, sx = _a.sx, children = _a.children;
    var _d = useState(null), originalAnchorZIndex = _d[0], setOriginalAnchorZIndex = _d[1];
    var _e = useState(null), previousAnchorElement = _e[0], setPreviousAnchorElement = _e[1];
    var _f = useState(null), arrowAnchorElement = _f[0], setArrowAnchorElement = _f[1];
    var theme = useTheme();
    useLayoutEffect(function () {
        if (!anchorElement) {
            return;
        }
        if (previousAnchorElement && previousAnchorElement !== anchorElement) {
            previousAnchorElement.style.zIndex = originalAnchorZIndex !== null && originalAnchorZIndex !== void 0 ? originalAnchorZIndex : '';
        }
        if (open) {
            var originalZIndex = anchorElement.style.zIndex;
            anchorElement.style.zIndex = '900';
            setOriginalAnchorZIndex(originalZIndex);
            setPreviousAnchorElement(anchorElement);
        }
        else {
            if (anchorElement) {
                anchorElement.style.zIndex = originalAnchorZIndex !== null && originalAnchorZIndex !== void 0 ? originalAnchorZIndex : '';
            }
            setOriginalAnchorZIndex(null);
            setPreviousAnchorElement(null);
        }
        return function () {
            if (originalAnchorZIndex) {
                anchorElement.style.zIndex = originalAnchorZIndex;
            }
        };
    }, [open, anchorElement]);
    if (!open || !anchorElement) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        showBackDrop ? (React.createElement(Container, { sx: {
                position: 'fixed',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                zIndex: 899,
                backgroundColor: "".concat(black, "80"),
            } })) : null,
        React.createElement(Popper, { open: true, anchorEl: anchorElement, placement: placement, modifiers: [
                {
                    name: 'arrow',
                    enabled: true,
                    options: { element: arrowAnchorElement },
                },
                { name: 'offset', options: { offset: [0, 20] } },
            ], sx: {
                maxWidth: '250px',
                zIndex: 901,
                '&[data-popper-placement*="bottom"] .arrow': {
                    top: 0,
                    left: 0,
                    marginTop: '-0.9em',
                    width: '3em',
                    height: '1em',
                    '&::before': {
                        borderWidth: '0 1em 1em 1em',
                        borderColor: "transparent transparent ".concat(theme.palette.background.paper, " transparent"),
                        content: '""',
                        margin: 'auto',
                        display: 'block',
                        width: 0,
                        height: 0,
                        borderStyle: 'solid',
                        filter: 'drop-shadow(0px -2px 1px rgba(0,0,0,0.25))',
                    },
                },
                '&[data-popper-placement*="top"] .arrow': {
                    bottom: 0,
                    left: 0,
                    marginBottom: '-0.9em',
                    width: '3em',
                    height: '1em',
                    '&::before': {
                        borderWidth: '1em 1em 0 1em',
                        borderColor: "".concat(theme.palette.background.paper, " transparent transparent transparent"),
                        content: '""',
                        margin: 'auto',
                        display: 'block',
                        width: 0,
                        height: 0,
                        borderStyle: 'solid',
                        filter: 'drop-shadow(0px 2px 1px rgba(0,0,0,0.25))',
                    },
                },
                '&[data-popper-placement*="right"] .arrow': {
                    left: 0,
                    marginLeft: '-0.9em',
                    height: '3em',
                    width: '1em',
                    '&::before': {
                        borderWidth: '1em 1em 1em 0',
                        borderColor: "transparent ".concat(theme.palette.background.paper, " transparent transparent"),
                        content: '""',
                        margin: 'auto',
                        display: 'block',
                        width: 0,
                        height: 0,
                        borderStyle: 'solid',
                        filter: 'drop-shadow(-2px 2px 1px rgba(0,0,0,0.25))',
                    },
                },
                '&[data-popper-placement*="left"] .arrow': {
                    right: 0,
                    marginRight: '-0.9em',
                    height: '3em',
                    width: '1em',
                    '&::before': {
                        borderWidth: '1em 0 1em 1em',
                        borderColor: "transparent transparent transparent ".concat(theme.palette.background.paper),
                        content: '""',
                        margin: 'auto',
                        display: 'block',
                        width: 0,
                        height: 0,
                        borderStyle: 'solid',
                        filter: 'drop-shadow(2px 2px 1px rgba(0,0,0,0.25))',
                    },
                },
            } },
            React.createElement("span", { className: "arrow", ref: setArrowAnchorElement }),
            React.createElement(Paper, { sx: __assign({ p: 2 }, sx) },
                React.createElement(Stack, { spacing: 1 },
                    React.createElement(Container, { disableGutters: true, sx: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        } },
                        React.createElement(Typography, null, children)))))));
};
export default TutorialBase;
//# sourceMappingURL=TutorialBase.js.map